import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { AIForProcessesComponent } from './ai-for-processes.component';
import { AIForProcessesService } from './services/ai-for-processes.service';
import { ProcessesTreeViewComponent } from './processes-tree-view/processes-tree-view.component';
import { ProcessesTreeViewNodeComponent } from './processes-tree-view-node/processes-tree-view-node.component';
import { KnowledgeComponent } from './knowledge/knowledge.component';
import { AiParametersSectionComponent } from './ai-parameters-section/ai-parameters-section.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    AIForProcessesComponent,
    ProcessesTreeViewComponent,
    ProcessesTreeViewNodeComponent,
    AiParametersSectionComponent,
    KnowledgeComponent
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    SharedModule
  ],
  exports: [
    AIForProcessesComponent
  ],
  providers: [
    AIForProcessesService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AIForProcessesModule { }
